export enum MessagesEnum {
  SUCCESS_CREATED = 'Registro criado com sucesso!',
  SUCCESS_CREATED_DOWNLOAD = 'Download criado com sucesso!',
  SUCCESS_CREATED_MARKETING = 'Marketing criado com sucesso!',
  SUCCESS_CREATED_TRAINING = 'Treinamento criado com sucesso!',
  SUCCESS_CREATED_EVENT = 'Evento criado com sucesso!',
  SUCCESS_CREATED_STATUS = 'Status criado com sucesso!',
  SUCCESS_CREATED_OS = 'Ordem de serviço criada com sucesso!',
  SUCCESS_CREATED_CUSTOMER_ACESS = 'Acesso criado com sucesso!',
  SUCCESS_UPDATED = 'Registro atualizado com sucesso!',
  SUCCESS_UPDATED_MARKETING = 'Marketing atualizado com sucesso!',
  SUCCESS_UPDATED_TRAINING = 'Treinamento atualizado com sucesso!',
  SUCCESS_UPDATED_EVENT = 'Evento atualizado com sucesso!',
  SUCCESS_UPDATED_DOWNLOAD = 'Download atualizado com sucesso!',
  SUCCESS_UPDATED_CUSTOMER_ACESS = 'Acesso atualizado com sucesso!',
  SUCCESS_UPDATED_STATUS = 'Status atualizado com sucesso!',
  SUCCESS_UPDATED_OS = 'Ordem de serviço atualizada com sucesso!',
  SUCCESS_DELETED = 'Registro removido com sucesso!',
  ERROR_TO_CREATE = 'Falha ao criar registro!',
  ERROR_TO_UPDATE = 'Falha ao atualizar registro!',
  ERROR_TO_DELETE = 'Falha ao remover registro!',
  ERROR_TO_CREATE_EVENT = 'Falha ao criar o formulario de evento!',
  SUCCESS_CANCEL = 'Cancelamento realizado com sucesso!',
  SUCCESS_CHECKOUT_OPEN = 'Caixa aberto com sucesso!',
  SUCCESS_CHECKOUT_CLOSE = 'Caixa fechado com sucesso!',
  CHECKOUT_IS_CLOSED = 'Caixa Fechado, para fazer alguma operação de venda o caixa deve estar aberto!',
  CHECKOUT_IS_NOT_CURRENT = 'Caixa não é do dia atual, feche o caixa e abra novamente para fazer alguma operação de venda ou alteração no caixa!',
  SUCCESSFUL_SALE = 'Venda finalizada com sucesso',
  SUCCESSFUL_SAVE_SALE = 'Venda salva com sucesso',
  DOESNT_CANCEL_ORDER_IN_CHECKOUT = 'Somente lançamentos e saídas podem ser cancelados no caixa, para cancelamento de vendas acesse vendas na tela principal',
  SUCCESS_OPERATION = 'Operação realizada com sucesso',
  SUCCESSFULL_ORDER_TRANSFER = "Transferência realizada com sucesso!",
  SUCCESSFUL_SALE_BUDGET = "Orçamento salvo com sucesso!",
  SUCCESSFUL_SALE_CANCEL = "Venda cancelada com sucesso!",
  NO_FILE_UPLOADED_YET = "Nenhum arquivo.",
  PASSWOWRD_RESET_SUCCESS = "Senha resetada com sucesso!",
  CUSTOMER_UNLOCK_SUCCESS = "Cliente desbloqueado com sucesso!",
  CUSTOMER_LOCK_SUCCESS = "Cliente bloqueado com sucesso!",
  CUSTOMER_INACTIVE_SUCCESS = "Cliente desativado com sucesso!",
  PARTNER_INACTIVE_SUCCESS = "Parceiro desativado com sucesso!",
  CUSTOMER_ACTIVE_SUCCESS = "Cliente ativado com sucesso!",
  PARTNER_ACTIVE_SUCCESS = "Parceiro ativado com sucesso!",
  LICENSE_GENERATED_SUCESS = "Licença gerada com sucesso!\n usuário: :user\n senha: :password",
  CONTRACT_GENERATED_SUCESS = "Contrato gerado com sucesso!",
  RESET_PASSWORD_CUSTOMER_TITLE = "Reset de senha do cliente: :name",
  CUSTOMER_WITHOUT_LICENSE_TO_RESET_PASSWORD = "Cliente sem licença para reset de senha!",
  CUSTOMER_WITHOUT_SIGNED_DOCUMENT_TO_GENERATE_LICENSE = "Cliente sem documentação assinada para gerar licença!",
  CUSTOMER_LICENSE_ALREADY_GENERATED = "Licença já gerada para este cliente!",
  EVENTS_WITHOUT_LICENSE_TO_RESET_PASSWORD = "senha teste",
  RESET_PASSWORD_EVENTS_TITLE = "Reset de senha do evento: :name",
  EVENTS_WITHOUT_SIGNED_DOCUMENT_TO_GENERATE_LICENSE = "EVENTO",
  EVENTS_UNLOCK_SUCCESS = "Evento desbloqueado com sucesso!",
  EVENTS_LOCK_SUCCESS = "Evento bloqueado com sucesso!",
  EVENTS_INACTIVE_SUCCESS = "Evento desativado com sucesso!",
  EVENTS_ACTIVE_SUCCESS = "Evento ativado com sucesso!",
  EVENTS_LICENSE_ALREADY_GENERATED = "Licença já gerada para este cliente!",
  PARTNER_LOCK_SUCCESS = "Parceiro bloqueado com sucesso!",
  PARTNER_RESET_PASSWORD_SUCCESS = "Senha resetada com sucesso!",
  PARTNER_UNLOCK_SUCCESS = "Parceiro desbloqueado com sucesso!",
  PARTNER_ACCESS_ALREADY_GENERATED = "Acesso já gerado para este parceiro!",
  ACCESS_GENERATED_SUCESS = "Acesso gerado com sucesso!\n usuário: :user\n senha: :password",
  PARTNER_WITHOUT_GENERATED_ACCESS = "Parceiro sem acesso gerado!",
  PARTNER_LOCK_PEOPLE_SUCCESS = "Carteira bloqueada com sucesso!",
  PARTNER_UNLOCK_PEOPLE_SUCCESS = "Carteira desbloqueada com sucesso!",
  SYSTEM_ALREADY_ADDED = "Sistema já adicionado!",
  PLAN_LOCK_SUCCESS = "Plano bloqueado com sucesso!",
  PLAN_UNLOCK_SUCCESS = "Plano desbloqueado com sucesso!",
  PASSWORD_NOT_MATCH = "Senhas não conferem!",
  SUCCESS_PASSWORD_CHANGE = "Senha alterada com sucesso!",
  EVENTS_SUCESSFULLY_GENERATED = "Formulario criado com sucesso!",
  PARCEL_UNLIKED_SUCCESS = "Parcela desvinculada com sucesso!",
  SUCCESS_WRITE_OFF = "Baixa realizada com sucesso!",
  NO_ITEM_SELECTED = "Nenhum item selecionado!",
  SUCCESS_REVERSE = "Estorno realizado com sucesso!",
  PAYOFF_SUCCESS = "Baixa realizada com sucesso!",
  DOES_NOT_HAVE_INFORMATION = "Não há informações!",
  PAYED_PARCEL_CANNOT_BE_CANCELED = "Parcela baixada não pode ser cancelada!",
  PARTNER_NOT_LINKED = "Parceiro não vinculado!",
  EXISTS_PARCEL_NOT_PAYABLE = "Existe(m) parcela(s) que não pode ser dado baixa!",
  PARCEL_CANNOT_BE_CANCELED = "Essa parcela não pode ser cancelada!",
  CREATE_SUCCESS = 'Registro criado com sucesso!',
  UPDATE_SUCCESS = 'Registro atualizado com sucesso!',
  DELETE_SUCCESS = 'Registro excluído com sucesso!',
  ERROR_UPDATING = 'Erro ao atualizar o registro!',
  PARTNER_WITH_GENERATED_ACCESS = 'O parceiro já possui acesso gerado.',
  PARTNER_GENERATE_ACCESS_SUCCESS = 'Acesso gerado com sucesso!',
  PARTNER_CONTRACT_GENERATION_SUCCESS = 'Contratos gerados com sucesso!',
  PARTNER_CONTRACT_GENERATION_ERROR = 'Erro ao gerar contratos. Tente novamente.',
  PARTNER_CONTRACT_TEMPLATE_SAVE_SUCCESS = 'Templates de contratos salvos com sucesso!',
  PARTNER_CONTRACT_TEMPLATE_SAVE_ERROR = 'Erro ao salvar templates de contratos. Tente novamente.',
  PARTNER_NO_ROLES_FOR_CONTRACTS = 'O parceiro não possui papéis atribuídos para gerar contratos.'
}
